export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8462.1d57c150.jpg";